import script from "./BigButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BigButton.vue?vue&type=script&setup=true&lang=ts"

import "./BigButton.vue?vue&type=style&index=0&id=216ffcbe&lang=scss"

const __exports__ = script;

export default __exports__